import { generatePath, Navigate, useLocation, useParams } from 'react-router-dom';

import { routePaths } from 'ui/authenticated/navigation';

export const LegacyIntegrationDetailRedirect = () => {
  const { integrationId = '', '*': section = null } = useParams();
  const { search, hash } = useLocation();

  return (
    <Navigate
      replace
      to={
        generatePath(routePaths.integrationDetail, { integrationId, '*': section }) + search + hash
      }
    />
  );
};
